export const SIGNATURE_DOCUMENT = {
  COMPANY: '*ATTACH*',
  NAME: 'Customer Signature'
} as const;

export const SIGNATURE_MODE = {
  DRAW: 'draw',
  TYPE: 'type'
} as const;
